module.exports = __webpack_public_path__ + "static/media/Factura.a14556e3.png";